import CorporateGroupsList from "../../../assets/data/CGroups";

export const findGroupByCriteria = (criteria, searchValue) => {
  if (!searchValue) return null;

  return CorporateGroupsList.find((group) => {
    switch (criteria) {
      case "value":
        return group.value === searchValue;
      case "email":
        return (
          group.email && searchValue === group.email.replace("@", "")
        );
      case "label":
        return group.label
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      default:
        return false;
    }
  });
};

export const filterGroupsByLabel = (searchValue) => {
  if (!searchValue?.trim()) return CorporateGroupsList;

  return CorporateGroupsList.filter((group) =>
    group.label.toLowerCase().includes(searchValue.toLowerCase()),
  );
};

export const isEmailDomainMatch = (userEmail, groupEmail) => {
  if (!userEmail || !groupEmail) return false;
  const userDomain = userEmail.split("@")[1];
  const groupDomain = groupEmail.replace("@", "");
  return userDomain === groupDomain;
};
